import { useTranslation } from 'react-i18next'

import { getFileItems, updateRequest } from '../../../../api'
import { NOTIFICATION_TYPE } from '../../../../constants/common'
import { FILE_SCOPE_REQUEST } from '../../../../constants/file'
import { FileAttachedItemsModal } from '../../../File'

import {
  getFilesItemsApiProps,
  getRequestAttachedFiles,
  getRequestNextAttachedFiles,
} from './useRequestTableItemAttachedFiles.utils'

export function useRequestTableItemAttachedFiles({
  onAddNotification,
  onCloseModal,
  onReload,
  onSetModal,
}) {
  const { t } = useTranslation()

  function handleSubmitRemoveAttachedFiles({ files, id, removedFiles }) {
    return updateRequest(
      getRequestNextAttachedFiles(files, removedFiles),
      id
    ).then(() => {
      onCloseModal()
      onReload(id)
      onAddNotification({
        title: t('Notification.CommonTitleRemovedAttachFilesKey'),
        type: NOTIFICATION_TYPE.success,
      })
    })
  }

  function handleClickFileTag({ directoryId, itemId }) {
    onSetModal(
      <FileAttachedItemsModal
        readonly
        ButtonCancel={false}
        ButtonRemove={false}
        directoryId={directoryId}
        entityId={itemId}
        filePreviewProps={{ scope: FILE_SCOPE_REQUEST, subject: itemId }}
        getApiProps={getFilesItemsApiProps}
        getData={getFileItems}
        getItemsFromResponse={getRequestAttachedFiles}
        objectId={itemId}
        onClose={onCloseModal}
        onSubmit={handleSubmitRemoveAttachedFiles}
      />
    )
  }

  return { handleClickFileTag }
}
